import { ReduxState } from "~/types/redux";
import { Product } from "~/types/products";
import { ModalKeys } from "~/constants/modal";
import { AddOnPriceSimplifiedProps } from "~/components/AddOn/simplified/AddOnPriceSimplified";

export const selectActiveModal = (state: ReduxState): ModalKeys | null =>
  (state.modal?.activeModal as ModalKeys) || null;

export const selectModalProduct = (state: ReduxState): Product | undefined => state.modal?.modalProduct;

export const selectModalPriceProduct = (state: ReduxState): AddOnPriceSimplifiedProps | undefined =>
  state.modal?.modalPriceProduct;

export const selectModalData = (state: ReduxState): Record<string, unknown> | undefined => state.modal?.modalData;

export const selectModalState = (state: ReduxState): ReduxState["modal"] => state.modal;

export const selectIsModalOpen = (state: ReduxState): boolean => Boolean(state.modal?.activeModal);

export const selectModalKey = (state: ReduxState): ModalKeys | null => (state.modal?.activeModal as ModalKeys) || null;
